<div class="agent-review-modal">
  <!-- Header -->
  <div mat-dialog-title class="modal-header">
    <div class="header-content">
      <mat-icon>fact_check</mat-icon>
      <h2>{{ "Confirm Your Document Details" | translate }}</h2>
    </div>
    <button mat-icon-button mat-dialog-close class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <mat-dialog-content class="modal-content">
    <!-- Info banner -->
    <div class="review-info-banner">
      <mat-icon>info</mat-icon>
      <div class="info-content">
        <strong>{{ "Verification Pending Confirmation" | translate }}</strong>
        <p>{{ "Please review and confirm the information extracted from your document" | translate }}</p>
      </div>
    </div>

    <!-- Extracted data display -->
    <div class="extracted-data" *ngIf="data.extractedData">
      <h4 class="section-title">{{ "Extracted Information" | translate }}</h4>
      
      <div class="data-grid">
        <!-- Personal Information -->
        <div class="data-section">
          <div class="section-header">
            <mat-icon>person</mat-icon>
            <span>{{ "Personal Information" | translate }}</span>
          </div>
          
          <div class="data-row" *ngIf="data.extractedData.fullName">
            <span class="label">{{ "Full Name" | translate }}:</span>
            <span class="value">{{ data.extractedData.fullName }}</span>
          </div>
          
          <div class="data-row" *ngIf="data.extractedData.cpf">
            <span class="label">{{ "CPF" | translate }}:</span>
            <span class="value">{{ data.extractedData.cpf }}</span>
          </div>
          
          <div class="data-row" *ngIf="data.extractedData.dateOfBirth">
            <span class="label">{{ "Date of Birth" | translate }}:</span>
            <span class="value">{{ data.extractedData.dateOfBirth | date: 'dd/MM/yyyy' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Confirmation prompt -->
    <div class="confirmation-prompt">
      <mat-icon>verified_user</mat-icon>
      <p>{{ "ConfirmDocumentDataPrompt" | translate }}</p>
    </div>

    <!-- Error message -->
    <div class="error-message" *ngIf="error">
      <mat-icon>error</mat-icon>
      <span>{{ error }}</span>
    </div>

    <!-- Loading spinner -->
    <div class="loading-overlay" *ngIf="confirming">
      <mat-spinner diameter="40"></mat-spinner>
      <p>{{ "Processing confirmation..." | translate }}</p>
    </div>
  </mat-dialog-content>

  <!-- Actions -->
  <mat-dialog-actions class="modal-actions">
    <button 
      class="def-button outline"
      (click)="cancel()"
      [disabled]="confirming">
      {{ "Cancel" | translate }}
    </button>
    <button 
      class="def-button black"
      (click)="confirmReview()"
      [disabled]="confirming">
      <mat-spinner *ngIf="confirming" diameter="20" style="display: inline-block; margin-right: 8px;"></mat-spinner>
      {{ confirming ? ('Processing...' | translate) : ('Confirm & Continue' | translate) }}
    </button>
  </mat-dialog-actions>
</div>
